import styled from "styled-components";

import { Modal } from "@/components/modal/modal";
import { Button } from "ui/ecosystems/forms";
import { NeedHelpButton } from "features/social-account-connect/components/need-help-button";
import { PlatformTypes } from "features/post";

export function NotApproved({
  className,
  onClose,
}: {
  className?: string;
  onClose(): void;
}) {
  return (
    <Modal.Body className={className}>
      <h5>It looks like we need a bit more time.</h5>
      <p>Sorry, it looks like we need a bit more time to check your account.</p>
      <p>
        We'll get in touch via email very shortly -- if you're in a rush, hit
        live chat below and we'll help you out right away.
      </p>
      <ModalActions>
        <NeedHelpButton
          platform={PlatformTypes.instagram}
          chatQuery="accounts"
        />
        <Button type="submit" primary onClick={onClose}>
          Ok
        </Button>
      </ModalActions>
    </Modal.Body>
  );
}

const ModalActions = styled.div`
  display: flex;
  justify-content: space-between;
`;
